import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.scss';
import AppBar from './AppBar';
import Login from './Login';
import DeliveryFileManagement from './deliveryfilemanagement/DeliveryFileManagement';
import FileManagement from './filemanagement/FileManagement';
import Portal from './portal/Portal';
import UploadDelivery from './uploaddelivery/UploadDelivery';
import UploadPage from './uploadpage/UploadPage';
import UploadUpdate from './uploadupdate/UploadUpdate';
import UserManagement from './usermanagement/UserManagement';
import AddUser from './adduser/AddUser';
import UserUpdate from "./updateuser/UpdateUser";
import FolderManagement from "./foldermanagement/FolderManagement";
import CreateFolder from "./createfolder/CreateFolder";
import SettingPermission from "./settingpermission/SettingPermission";
import ManageService from "./manageservice/ManageService";
import SettingSharedFolder from "./settingsharedfolder/SettingSharedFolder";
import UploadSchedule from "./uploadschedule/UploadSchedule";

// TODO 認証処理実装後にログイン部分は削除
function App() {
	return (
		<BrowserRouter basename="/">
			<AppBar />
			<div className="app-content">
				<Routes>
					<Route path="/" element={<Portal />} />
					<Route path="/portal" element={<Portal />} />
					<Route path="/filemanagement" element={<FileManagement />} />
					<Route path="/upload" element={<UploadPage />} />
					<Route path="/deliveryfileManagement" element={<DeliveryFileManagement />} />
					<Route path="/uploaddelivery" element={<UploadDelivery />} />
					<Route path="/uploadupdate" element={<UploadUpdate />} />
					<Route path="/userManagement" element={<UserManagement />} />
					<Route path="/addUser" element={<AddUser />} />
					<Route path="/updateUser" element={<UserUpdate />} />
					<Route path="/folderManagement" element={<FolderManagement/>} />
					<Route path="/createFolder" element={<CreateFolder/>}/>
					<Route path="/settingPermission" element={<SettingPermission/>}/>
					<Route path="/manageService" element={<ManageService/>}/>
					<Route path="/settingSharedFolder" element={<SettingSharedFolder/>}/>
					<Route path="/uploadSchedule" element={<UploadSchedule/>}/>
				</Routes>
			</div>
		</BrowserRouter>
		// <BrowserRouter >
		// 	<AppBar />
		// 	<div className="app-content">
		// 		<Routes>
		// 			<Route path="/portal" element={<Portal />} />
		// 			<Route path="/filemanagement" element={<FileManagement />} />
		// 			<Route path="/upload" element={<UploadPage />} />
		// 			<Route path="/deliveryfileManagement" element={<DeliveryFileManagement />} />
		// 			<Route path="/uploaddelivery" element={<UploadDelivery />} />
		// 			<Route path="/uploadupdate" element={<UploadUpdate />} />
		// 		</Routes>
		// 	</div>
		// </BrowserRouter>
	);
}

export default App;
